import React, { useRef } from 'react';
import styled from 'styled-components';

import { useModal } from '../../../../Providers/ModalContext';
import Modal from '../../../../Global/Modal';
import RichText from '../../../../Global/RichText';
import { Gallery } from '../../../../Global/Gallery';

import CloseIcon from '../../../../../Images/icons/close-icon.png';
import PhotoBg from '../../../../../Images/background/bg_photo.png';
import LogoStudio from '../../../../../Images/logos/logo-studio.png';

import {
  Photo_Title,
  TextPhoto3_Alejandro,
} from '../../../../../utils/ES/Modals/photographers';

import Photo1 from '../../../../../Images/modals/photographers/alejandro/gallery3/img_1.png';
import Photo2 from '../../../../../Images/modals/photographers/alejandro/gallery3/img_2.png';
import Photo3 from '../../../../../Images/modals/photographers/alejandro/gallery3/img_3.png';

const Gallery1 = [
  { id: 1, src: Photo1, colSpan: 2, rowSpan: 5 },
  { id: 2, src: Photo2, colSpan: 2, rowSpan: 5 },
  { id: 3, src: Photo3, colSpan: 2, rowSpan: 5 },
];

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const ModalContent = styled.div`
  width: 100%;
  position: relative;
  padding: 25px 60px;
  display: flex;
  align-items: flex-start;

  flex-direction: column;
  gap: 2.5rem;

  p,
  h2,
  h3 {
    text-transform: uppercase;
  }

  .left-align {
    width: 100%;
    text-align: right;
  }
`;

const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 3.375rem;

  p {
    text-transform: uppercase;
  }
`;

const LogoContent = styled.div`
  display: block;
  max-width: 276px;
  width: 100%;
  padding: 15px;
  position: relative;

  img {
    display: block;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease-out;

    &:hover {
      filter: drop-shadow(0px 0px 20px rgba(250, 115, 19, 1));
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 93px;
    background: #fff;

    top: 0;
    bottom: 0;

    margin: auto;
    right: -10%;
  }
`;

const ModalGalleryAlejandro3 = () => {
  const { closeModal } = useModal();

  return (
    <>
      <Modal id="alejandro-gallery-3" bgImg={PhotoBg}>
        <CloseContainer>
          <CloseButton
            onClick={closeModal}
            aria-label="Close modal"
            src={CloseIcon}
          />
        </CloseContainer>
        <ModalContent>
          <TitleContent>
            <LogoContent>
              <img
                src={LogoStudio}
                onClick={closeModal}
                aria-label="Close modal"
                alt="Kuter Studio"
              />
            </LogoContent>
            <RichText dataText={Photo_Title} />
          </TitleContent>
          <Gallery images={Gallery1} columns={6} />
          <RichText className="left-align" dataText={TextPhoto3_Alejandro} />
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalGalleryAlejandro3;
